module.exports = __webpack_public_path__ + "img/fasapay_static.b5130fd2.svg";